class ImageZoom extends HTMLElement {
	constructor() {
		super();
		this.image = this.querySelector('img');
		if (!this.image) return;

		this.addEventListener('mousemove', this.onMouseMove.bind(this));
		this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
		this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
	}

	onMouseEnter() {
		this.image.style.transform = 'scale(2)';
		this.image.style.transition = 'transform 0.1s ease';
	}

	onMouseMove(event) {
		const bounds = this.getBoundingClientRect();
		const x = ((event.clientX - bounds.left) / bounds.width) * 100;
		const y = ((event.clientY - bounds.top) / bounds.height) * 100;

		this.image.style.transformOrigin = `${x}% ${y}%`;
	}

	onMouseLeave() {
		this.image.style.transform = 'scale(1)';
	}
}

customElements.define('image-zoom', ImageZoom);
